import React from "react";
import { reportError } from "@/lib/errorReporter";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError({
      message: error?.message || "React error",
      stack: (error?.stack || "") + "\n---componentStack---\n" + (info?.componentStack || ""),
      source: "react",
    });
  }

  handleReload = () => {
    this.setState({ hasError: false });
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="error-boundary">
        <div className="max-w-md w-full rounded-lg border border-border bg-white shadow-sm p-8 text-center">
          <div className="font-serif text-2xl text-primary">Something went wrong</div>
          <p className="mt-3 text-sm text-muted-foreground">
            An unexpected error occurred. The Arogya Pramana team has been notified if you consented to diagnostics.
          </p>
          <button
            onClick={this.handleReload}
            className="mt-6 inline-flex items-center rounded-md bg-primary text-white px-4 py-2 text-sm"
            data-testid="error-boundary-reload"
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
